import {
  APIPaginatedRequest,
  CountRequest,
  getFetcherV2,
} from "shared/api/api";
import { clientV2 } from "shared/api/axios";
import { createURL } from "shared/api/utils";

const ASSETS_BASE_URL = "assets";

export interface Asset {
  ID: string;
  VIN: string | null;
  body: string | null;
  brakeModel: string | null;
  color: string | null;
  company: string | null;
  country: string | null;
  createdAt: string;
  createdBy: string;
  domicile: string | null;
  engineModel: string | null;
  engineSupplierCode: string | null;
  externalID: string | null;
  firstSaleDate: string | null;
  fleet: string | null;
  fuelType: string | null;
  gvwr: string | null;
  inServiceDate: string | null;
  licensePlate: string | null;
  make: string | null;
  model: string | null;
  modelYear: number | null;
  name: string;
  outOfServiceDate: string | null;
  platform: string | null;
  transmissionModel: string | null;
  trimLevel: string | null;
  type: string | null;
  updatedAt: string;
  updatedBy: string;
  axleConfigID: string | null;
  tireSettingID: string | null;
  tireSettingName: string | null;
  driverID: string | null;
}

export interface GetAssetRequest {
  id: string;
}

export interface ListAssetsRequest extends APIPaginatedRequest {}

export interface UpdateAssetRequest {
  id: string;
  tireSettingID?: string | null;
  axleConfigID?: string | null;
  driverID?: string | null;
}

export interface CountRequestWithAssetsFilter extends CountRequest {
  assetsFilter?: string;
  analytics?: boolean;
}

// --------
// List Assets
// --------
export const listAssetsRequestURI = (params: ListAssetsRequest): string =>
  clientV2.getUri({
    method: "get",
    url: `/${ASSETS_BASE_URL}`,
    params,
  });

// --------
// Get Single Asset
// --------
export const getAssetRequestURI = ({ id }: GetAssetRequest): string =>
  clientV2.getUri({
    method: "get",
    url: createURL([ASSETS_BASE_URL, id]),
  });

// --------
// Asset Count
// --------
export const listAssetsCountRequestURI = (
  params: CountRequestWithAssetsFilter
): string =>
  clientV2.getUri({
    method: "get",
    url: createURL([ASSETS_BASE_URL, "count"]),
    params,
  });

// --------
// Update Asset
// --------
export const updateAsset = ({ id, ...data }: UpdateAssetRequest) =>
  clientV2.patch<Asset>(createURL([ASSETS_BASE_URL, id]), data);

export const listAssets = (args: APIPaginatedRequest) => {
  const url = listAssetsRequestURI(args);

  return getFetcherV2<Asset[]>(url);
};
